<!-- App.vue-->

<template>
  <v-app>
    <Login v-if="!isLoggedIn" @login="handleLogin" />

    <v-container v-else>
      <v-tabs v-model="activeTab" background-color="primary" dark>
        <v-tab>Панель управления</v-tab>
        <v-tab>Зоны</v-tab>
        <v-tab>Точки</v-tab>
        <v-tab>Проблемы</v-tab>
        <v-tab>Настройки</v-tab>
        <v-tab>Профиль</v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <AdminDashboard />
        </v-tab-item>

        <v-tab-item>
          <Zones />
        </v-tab-item>

          <v-tab-item>
        <AdminMapPoints />
         </v-tab-item>

        <v-tab-item>
          <ProblemAddresses />
        </v-tab-item>

        <v-tab-item>
           <AdminSettings />
        </v-tab-item>

        <v-tab-item>
          <Profile @logout="handleLogout" />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </v-app>
</template>

<script>
import Login from "./components/Login.vue";
import AdminDashboard from "./components/AdminDashboard.vue";
import Zones from "./components/AdminZones.vue";
import AdminMapPoints from "./components/AdminMapPoints.vue";
import Profile from "./components/AdminProfile.vue";
import ProblemAddresses from './components/ProblemAddresses.vue';
import AdminSettings from './components/AdminSettings.vue';

export default {
  name: "App",
  data() {
    return {
      isLoggedIn: !!localStorage.getItem('token'),
      activeTab: 0,
    };
  },
  methods: {
    handleLogin() {
      this.isLoggedIn = true;
      localStorage.setItem('token', '4FGNFY42DSfWCW3DQW3RW4TGEGET');
    },
    handleLogout() {
      this.isLoggedIn = false;
      localStorage.removeItem('token');
      this.activeTab = 0;
    },
  },
  components: {
    Login,
    AdminDashboard,
    Zones,
    AdminMapPoints,
    Profile,
    ProblemAddresses,
    AdminSettings
  },
};
</script>

